module.exports = __webpack_public_path__ + "static/Milan_Misak_Severanka-f15222f8de9739dcefd96083a90d5a61.mp3";